import React from 'react';
import { Form } from 'antd';
import { useMutation, useNavigate } from '@common/hooks';
import { useSetBreadcrumbs } from 'works/legacy/lib/client-store';
import { createMessage } from 'works/legacy/lib/message-helper';
import { addErrorsToForm } from 'works/legacy/lib/form-helpers';
import { CreateWorksListTemplateMutation } from 'works/legacy/graphql/works-list-template';
import { OnboardingListsForm } from 'works/legacy/pages/organization/admin-settings/templates-page/onboarding-list-templates/onboarding-lists-form';
import { ORGANIZATION_ADMIN_MENU } from 'works/legacy/pages/organization/admin-settings/organization-admin-vertical-nav-menu';

export function OnboardingListTemplateNewPage() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const initialValues = {};

  useSetBreadcrumbs([
    {
      name: 'Admin',
      path: '/works/admin',
    },
    {
      name: 'Templates',
      path: '/works/admin/templates',
    },
    {
      name: ORGANIZATION_ADMIN_MENU.TEMPLATES__COMPLIANCE.LABEL,
      path: ORGANIZATION_ADMIN_MENU.TEMPLATES__COMPLIANCE.ROUTE,
    },
    {
      name: 'New Compliance List Template',
      path: `${ORGANIZATION_ADMIN_MENU.TEMPLATES__COMPLIANCE.ROUTE}/new`,
    },
  ]);

  const [createWorksListTemplate, { loading }] = useMutation(
    CreateWorksListTemplateMutation,
    {
      onCompleted(response) {
        if (response.createWorksListTemplate.errors) {
          addErrorsToForm(form, response.createWorksListTemplate.errors);
        } else {
          createMessage(
            'success',
            'Compliance List Template has been created!'
          );
          navigate('/works/admin/templates/compliance-list');
        }
      },
      onError: () => {
        createMessage(
          'error',
          'Failed to create Compliance List Template. Please try again or contact your hiring partner.'
        );
      },
    }
  );

  const onFinish = (values) => {
    createWorksListTemplate({
      variables: {
        input: {
          name: values.name,
          complianceDeadlineDetails: values.complianceDeadlineDetails,
        },
      },
    });
  };

  return (
    <OnboardingListsForm
      onFinish={onFinish}
      form={form}
      loading={loading}
      initialValues={initialValues}
      submitLabel="Create"
    />
  );
}
